import { GradeDetailDto, GradeEditDto } from './grade';

export const mapGradeDetailToEdit = (dto: GradeDetailDto): GradeEditDto => ({
  id: dto.id,
  no: dto.no,
  name: dto.name,
  description: dto.description,
  active: dto.active,
  corrected: dto.corrected,
  internal: dto.internal,
  gradeParameters: dto.gradeParameters,
  gradeCorrections: dto.gradeCorrections
});
